import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { AdminActivityLogTableQuery } from '../../../models/system-settings/admin-activity-log.model';

@Injectable({ providedIn: 'root' })
export class ApiAdminActivityLogService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  private get token(): string {
    return this.cookieService.get('token');
  }

  getAdminActivityLogsForTable(query: AdminActivityLogTableQuery): Observable<unknown> {
    const params: Record<string, string | number> = {
      page: query.page ?? 1,
      pageSize: query.pageSize ?? 20,
    };
    if (query.startDate) params['startDate'] = query.startDate;
    if (query.endDate) params['endDate'] = query.endDate;
    if (query.actorUserId) params['actorUserId'] = query.actorUserId;
    if (query.entityType) params['entityType'] = query.entityType;
    if (query.entityId) params['entityId'] = query.entityId;
    if (query.action) params['action'] = query.action;
    if (query.searchText) params['searchText'] = query.searchText;

    return this.apiMethodService.request<unknown>('/SystemSettings/getAdminActivityLogsForTable', 'GET', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'getAdminActivityLogsForTable',
      token: this.token,
      headerOnly: false,
      params,
    });
  }

  getAdminActivityLogById(id: number): Observable<unknown> {
    return this.apiMethodService.request<unknown>('/SystemSettings/getAdminActivityLogById', 'GET', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'getAdminActivityLogById',
      token: this.token,
      headerOnly: false,
      params: { id },
    });
  }
}
